import update from 'immutability-helper';
import R from 'ramda';

import {
    SET_SURVEY_ANSWERS, UPSERT_SERVEY_ANSWER, UPDATE_SURVEY_ANSWER
} from '_actions/answers';

import { LOGOUT_USER } from '_actions/user';

const format = answers => {
    return Object.entries(answers).map(answer => {
        return ({sID: answer[0], qID: answer[1], answer: answer[2], encrypted_field: answer[3]})
    });
};

export function answer(state = {}, action) {
    switch (action.type) {
        case UPSERT_SERVEY_ANSWER:
            return update(state, {
                sID: { $set: action.sID },
                qID: { $set: action.qID },
                answer: { $set: action.answer },
                encrypted_field: { $set: action.encrypted_field }
            });
        case UPDATE_SURVEY_ANSWER:
            return update(state, {
                sID: { $set: action.sID },
                qID: { $set: action.qID },
                answer: { $set: action.answer },
                encrypted_field: { $set: action.encrypted_field }
            });
        default:
            return state;
    }
}

export default function answers(state = [], action) {
    const index = R.findIndex(R.propEq('qID', action.qID), state);
    const updatedAtIndex = { $splice: [[index, 1, answer(state[index], action)]] };

    switch (action.type) {
        case SET_SURVEY_ANSWERS:
            return update(state, { $set: action.answers }); //TODO: only set relevant answers (ignore other surveys)
        case UPSERT_SERVEY_ANSWER:
            if(index != -1) {
                return update(state, updatedAtIndex);
            } else {
                return update(state, { $push: [answer(undefined, action)] });
            }
        case UPDATE_SURVEY_ANSWER:
            return update(state, updatedAtIndex);
        case LOGOUT_USER:
            return [];
        default:
            return state;
    }
}